import { ChangeDetectionStrategy, Component, inject, OnInit, viewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';

import { PaymentSubmitEvent, TabPaymentFormInputs } from './tab-payment-form.model';
import { TabPaymentFormComponent } from './tab-payment-form.component';

@Component({
  selector: 'app-tab-payment-dialog',
  imports: [ MatDialogModule, TabPaymentFormComponent ],
  template: `
    <div class="bg-night text-white max-h-[90vh] overflow-y-auto p-4 lg:p-6">
      <app-tab-payment-form
        #paymentForm
        [data]="data"
        [submitting]="false"
        (cancel)="dialogRef.close()"
        (submit)="dialogRef.close($event)" />
    </div>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TabPaymentDialogComponent implements OnInit {
  dialogRef = inject(MatDialogRef<TabPaymentDialogComponent, PaymentSubmitEvent>);
  data = inject<TabPaymentFormInputs>(MAT_DIALOG_DATA);

  private paymentForm = viewChild<TabPaymentFormComponent>('paymentForm');

  ngOnInit(): void {
    setTimeout(() => this.paymentForm()?.resetForm());
  }
}
